export const DOCUMENTATION_URL =
  "https://docs.viesus.com/get-started/quickstart-cloud?utm_source=viesus_cloud&utm_medium=web_app&utm_campaign=documentation_link"
